import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Http, Headers } from '@angular/http';
//import { HttpClientModule } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CoreService } from '../core/core.service';
import { EkubService } from './ekub.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-ekub-add',
  templateUrl: './ekub.add.component.html',
  styleUrls: ['./ekub.add.component.scss']
})

export class EkubAddComponent {

  ekub: any = {};
  isLoading: any;
  id: string;
  message: string = 'Ekub 1';
  ekubForm!: FormGroup;
  config: any;
  operation: string;
  categories: any[];
  banks: any[];
  accounts: any[];

  file: any;
  files: File[] = [];
  files_temp: any = [];
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;

  uploading = false;
  successUploadCount = 0;
  failedUploadCount = 0;
  error: string;
  userId: number = 1;
  uploadResponse = { status: '', message: '', filePath: '' };


  constructor(private http: Http, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private coreService: CoreService,

    private imageCompress: NgxImageCompressService, private api: EkubService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.ekub = {
      ekub_id: null,
      start_date: null,
      end_date: null,
      category: null,
      qualification_threshold: 0,
      length: 0,
      total_members: 0,
      service_charge: 2,
      total_due: 0,
      registered: 0,
      status: 'pending',
      remark: ''
    };
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      this.getEkub();
    }
    this.operation = 'add';
  }

  //get ekub_id() { return this.ekubForm.get('ekub_id'); }
  get bank() { return this.ekubForm.get('bank'); }
  get account() { return this.ekubForm.get('account'); }
  get start_date() { return this.ekubForm.get('start_date'); }
  get end_date() { return this.ekubForm.get('end_date'); }
  get ekubValue() { return this.ekubForm.get('value'); }
  get service_charge() { return this.ekubForm.get('service_charge'); }
  get total_due() { return this.ekubForm.get('total_due'); }
  get category() { return this.ekubForm.get('category'); }
  get qualification_threshold() { return this.ekubForm.get('qualification_threshold'); }
  get first_awards() { return this.ekubForm.get('first_awards'); }
  get first_award_on() { return this.ekubForm.get('first_award_on'); }
  get length() { return this.ekubForm.get('length'); }
  get total_members() { return this.ekubForm.get('total_members'); }
  get registered() { return this.ekubForm.get('registered'); }
  get status() { return this.ekubForm.get('status'); }
  get remark() { return this.ekubForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    if (!this.id) {
      this.getAllCategories();
      this.getBanks();
    }
  }

  private createForm() {

    this.ekubForm = this.formBuilder.group({
      bank: ['', [Validators.required,]],
      account: ['', [Validators.required,]],
      start_date: ['', [Validators.required,]],
      end_date: ['', [Validators.required,]],
      ratio: [''],
      value: [0],
      service_charge: [2],
      total_due: [0],
      category: [null, [Validators.required]],
      qualification_threshold: [0, Validators.required],
      first_awards: [2, Validators.required],
      first_award_on: [3, Validators.required],
      length: [0, Validators.required],
      total_members: [1, [Validators.required, Validators.min(1)]],
      registered: [0, [Validators.required]],
      status: ['pending', Validators.required],
      remark: [''],
    });
  }

  getEkub() {
    debugger;
    this.api.getEkub(this.id).subscribe((res: any) => {
      debugger;
      this.ekub = Object.assign(this.ekub, res.data);
      let startDate = this.ekub.start_date.split(" ")[0];
      let endDate = this.ekub.end_date.split(" ")[0];
      this.start_date.setValue(startDate);
      this.end_date.setValue(endDate);
      this.total_members.setValue(this.ekub.total_members);
      this.service_charge.setValue(this.ekub.service_charge);
      this.total_due.setValue(this.ekub.total_due);
      this.qualification_threshold.setValue(this.ekub.qualification_threshold);
      this.first_awards.setValue(this.ekub.first_awards);
      this.length.setValue(this.ekub.length);
      this.registered.setValue(this.ekub.registered);
      this.status.setValue(this.ekub.status);
      this.remark.setValue(this.ekub.remark);
      this.first_award_on.setValue(this.ekub.first_award_on);
      this.getAllCategories(this.ekub.category.data.id);
      this.getBanks(this.ekub.account.data.id);
    });
  }

  getAllCategories(_selectedCategory: String = null) {
    debugger;
    this.api.getAllCategories().subscribe((res: any) => {
      debugger;
      this.categories = res.data;
      for (let category of this.categories) {
        category.text = category.title;
        category.title = category.title + ' - ' + category.amount + ' ETB / ' + category.interval;
        category.id = category.id;
      }
      if (_selectedCategory) {
        var cat = this.categories.filter(
          (category: any) => category.id.toLowerCase().indexOf(_selectedCategory.toLowerCase()) !== -1
        );
        this.category.setValue(cat[0]);
      }
    });
  }

  getBanks(_selectedBank: String = null) {
    this.api.getAllBanks('&distinct=true').subscribe((res: any) => {
      debugger;
      this.banks = res.data;
      for (let bank of this.banks) {
        bank.title = bank.bank + ' - ' + bank.accronym;
        bank.id = bank.id;
        // bank.id = bank.accronym;
      }
      if (_selectedBank) {
        var bnk = this.banks.filter(
          (bank: any) => bank.id.toLowerCase().indexOf(_selectedBank.toLowerCase()) !== -1
        );
        this.bank.setValue(bnk[0]);
        this.getBankAccounts(bnk[0].accronym, _selectedBank);
      }
    });

  }

  getBankAccounts(bank, _selectedAccount = null) {
    debugger;
    this.api.getBankAccounts(bank).subscribe((res: any) => {
      debugger;
      this.accounts = res.data;
      for (let account of this.accounts) {
        account.title = account.account_number + ' - ' + account.created_at;
        account.
          id = account.id;
      }
      if (_selectedAccount) {
        var act = this.accounts.filter(
          (account: any) => account.id.toLowerCase().indexOf(_selectedAccount.toLowerCase()) !== -1
        );
        this.account.setValue(act[0]);
      }
    });
  }

  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  setCategory(category: any) {
    debugger;
  }

  async calculate() {
    debugger;
    //var ekubValue: number = Math.pow(this.total_members.value, 2) * this.category.value.amount;
    this.ekubValue.setValue(parseInt(this.total_members.value) * parseInt(this.category.value.amount));
    this.length.setValue(parseInt(this.total_members.value) + parseInt(this.first_award_on.value) - parseInt(this.first_awards.value));
    this.total_due.setValue(parseInt(this.category.value.amount) + parseInt(this.category.value.amount) * parseInt(this.service_charge.value) / 100);
    console.log('simulating ...');
    var res = await this.calculateEndDate();
  }

  async calculateEndDate() {
    debugger;
    var days: number = 0;
    switch (this.category.value.interval) {
      case 'weekly':
        days = this.total_members.value * 7;
        break;
      case 'monthly':
        days = this.total_members.value * 30;
        break;
      case 'daily':
        days = this.total_members.value;
        break;
    }
    //this.category.value.total_members;
    var startDate = new Date(this.start_date.value);
    var endDate: Date = await startDate;
    endDate.setDate(endDate.getDate() + days);
    this.end_date.setValue((endDate).toISOString().substring(0, 10));
    console.log(this.end_date.value);
    console.log(this.end_date.value - this.start_date.value);
  }

  getInterval(interval: String) {
    switch (interval) {
      case 'weekly':
        return 'weeks';
      case 'monthly':
        return 'months';
      case 'daily':
        return 'days';
    }
  }
  async addEkub() {
    debugger;
    await this.calculate();
    this.isLoading = !this.isLoading;
    this.ekub = this.ekubForm.value;
    this.ekub.category = this.ekubForm.value.category.id;
    this.ekub.bank = this.bank.value.id;
    this.ekub.account = this.account.value.id;
    //var id = this.ekub.id != null ? this.ekub.id : null;
    this.api.createEkub(this.ekub, this.id).subscribe((res: any) => {
      //this.api.createEkub({ ekub: this.ekub }, this.id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Ekub successfully updated! ' : 'Ekub  successfully added!', type: 'dark' });
      this.router.navigate(['/ekubs']);
    }, (err) => {
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Could not update ekub!' : 'Could not add ekub!', type: 'danger' });
    });

  }



  // File upload

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
    console.log(this.files);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
    console.log(this.files);

  }

  onFilesAdded(files: any) {
    let j = 0;
    this.files = files.addedFiles;
    console.log('this.files');
    console.log(this.files);
    for (let file of this.files) {
      if (j > 4) {
        break;
      }
      let fileName: any;
      fileName = file['name'];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.localUrl = event.target.result;
          this.compressFile(this.localUrl, fileName);
        }
        reader.readAsDataURL(file);
      }
      j++;
    }
  }

  compressFile(image: any, fileName: string) {
    var orientation = -1;
    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    // console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
    this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
        // console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
        const imageName = fileName;
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
        const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
        this.files_temp.push(imageFile);
      });
    console.log('this.files_temp');
    console.log(this.files_temp);
  }


  dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }


  public async uploadFile(id: any) {
    debugger;
    this.successUploadCount = 0;
    this.failedUploadCount = 0;
    /* for (let file of this.files) { */
    for (let file of this.files_temp) {
      console.log(file);
      const formData = new FormData();
      if (file instanceof File) {
        formData.append('file', file, file.name);
        this.uploading = true;
        await this.api.upload(formData, id).then((res: any) => {
          debugger;
          this.uploadResponse = res;
          console.log(res);
          if (this.uploadResponse.status !== 'progress' &&
            this.uploadResponse.status !== 'unhandeled event') {
            this.successUploadCount++;
            let temp = (this.successUploadCount / this.files.length) * 100;
            this.uploadResponse.message = temp.toString();
          }
        }, function (err) {
        });
      }

    }
    this.mainService.toast({ title: 'Success', body: (this.id) ? 'Ekub pictures successfully updated! ' : 'Ekub pictures successfully added!', type: 'dark' });
    this.router.navigate(['/ekubs'], { queryParams: { subject: 'post' } });

  }

}
